import { signal, computed } from "@preact/signals-react";
import { DataConnectionPreview } from "./DataConnectionPreview";

//#region Signals
const splitterPaneSize = signal({
  0: { size: "30%" },
  1: { size: "70%" },
});

export const splitterPanes = computed(() => {
  return [
    {
      size: splitterPaneSize.value[0].size,
      resizable: true,
      scrollable: false,
    },
    {},
  ];
});
//#endregion

export const DataConnectionConfigurator = () => {
  return <DataConnectionPreview />;
};
